/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getReporterStats'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  dids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    maxLength: 100,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  stats: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ModerationDefs.ReporterStats>(
      (() => ModerationDefs.reporterStats) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get reporter stats for a list of users. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
